import { createFileRoute } from '@tanstack/react-router'
import SuppliersPage from '@/pages/suppliers'

export const Route = createFileRoute('/suppliers/')({
  component: SuppliersPage
})
